export default __webpack_public_path__ + "static/media/nobooking.05a6e952.svg";